var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCarbonAddFilled(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_106_251)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8 0.5C5.88619 0.525503 3.86614 1.37655 2.37134 2.87134C0.876545 4.36614 0.0255025 6.38619 0 8.5C0.0255025 10.6138 0.876545 12.6339 2.37134 14.1287C3.86614 15.6235 5.88619 16.4745 8 16.5C10.1138 16.4745 12.1339 15.6235 13.6287 14.1287C15.1235 12.6339 15.9745 10.6138 16 8.5C15.9745 6.38619 15.1235 4.36614 13.6287 2.87134C12.1339 1.37655 10.1138 0.525503 8 0.5ZM12.5714 9.07143H8.57143V13.0714H7.42857V9.07143H3.42857V7.92857H7.42857V3.92857H8.57143V7.92857H12.5714V9.07143Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_106_251"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCarbonAddFilled);
export default __webpack_public_path__ + "static/media/carbon_add-filled.dd157c84795e1b485a8d30b3ac5ec39d.svg";
export { ForwardRef as ReactComponent };